(function () {
    'use strict';

    a3_cabin_reports.directive('passengerShopOrders', passengerShopOrders);

    /**
     * @memberof CabinReports
     * @ngdoc directive
     * @name passengerShopOrders
     * @restrict E
     * @description
     *   Manages the shop order for a single passenger
     * @example
     *   Usage:
     *   <passenger-shop-orders></passenger-shop-orders>
     * @ngInject
     */
    function passengerShopOrders($timeout, FlightOrdersFactory, CabinReportLocalEditFactory, $uibModal) {
        function link($scope) {
    
            function getOrdersForThePassenger(flightId, passenger) {
                $scope.passengerOrder = null;
                $scope.noOrdersAvailable = false;
            
                // Retrieve cabin report
                const report = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(flightId);
            
                // Use report data if available
                if (report && report.FlightOrders && report.FlightOrders.Orders) {
                    const reportOrder = report.FlightOrders.Orders.find(
                        o => o.Passenger &&
                             o.Passenger.PNR === passenger.PNR &&
                             o.Passenger.LastName === passenger.Surname &&
                             o.Passenger.FirstName === passenger.GivenName
                    );
            
                    if (reportOrder) {
                        $scope.passengerOrder = {
                            OrderNumber: reportOrder.OrderNumber,
                            OrderStatus: reportOrder.Status || "Pending",
                            Feedback: reportOrder.Feedback || '',
                            Reason: reportOrder.Reason || '',
                            Photos: reportOrder.Photos || [],
                            Items: (reportOrder.Items && reportOrder.Items.map(item => ({
                                Title: item.Title,
                                Quantity: item.Quantity,
                            }))) || [],
                            ReasonError: false,
                        };
                        return;
                    }
                }
            
                // Fallback to FlightOrdersFactory data
                const flattenedOrders = FlightOrdersFactory.getFlightOrdersFlattenedByFlightId(flightId);
                if (flattenedOrders && flattenedOrders.Orders) {
                    const matchingOrder = flattenedOrders.Orders.find(
                        order => order.Passenger &&
                                 order.Passenger.PNR === passenger.PNR &&
                                 order.Passenger.LastName === passenger.Surname &&
                                 order.Passenger.FirstName === passenger.GivenName
                    );
            
                    if (matchingOrder) {
                        $scope.passengerOrder = {
                            OrderNumber: matchingOrder.OrderNumber,
                            OrderStatus: matchingOrder.Status || "Pending",
                            Feedback: matchingOrder.Feedback || '',
                            Reason: matchingOrder.Reason || '',
                            Photos: matchingOrder.Photos || [],
                            Items: (matchingOrder.Items && matchingOrder.Items.map(item => ({
                                Title: item.Title,
                                Quantity: item.Quantity,
                            }))) || [],
                            ReasonError: false,
                        };
                    } else {
                        $scope.noOrdersAvailable = true;
                    }
                } else {
                    $scope.noOrdersAvailable = true;
                }
            }
            
        
            // Initial call to populate orders
            getOrdersForThePassenger($scope.flight.FlightId, $scope.passenger);
          
            // Change Order Status
            $scope.changeOrderStatus = function (status) {
                $scope.passengerOrder.OrderStatus = status;
                if (status === 'Delivered') {
                    $scope.passengerOrder.ReasonError = false;
                    $scope.passengerOrder.Reason = '';
                    $scope.passengerOrder.Feedback = '';
                } else if (status === 'Not Delivered') {
                    $scope.passengerOrder.ReasonError = false;
                    $scope.passengerOrder.Reason = '';
                    $scope.passengerOrder.Feedback = '';
                }
            };

            // Validate Reason
            $scope.validateReason = function () {
                $scope.passengerOrder.ReasonError = !$scope.passengerOrder.Reason;
            };

            // Attach a Photo
            $scope.attachPhoto = function () {
                const modalInstance = $uibModal.open({
                    templateUrl: 'views/Dialogs/dlgItemPhotos.html',
                    controller: 'ItemPhotosCtrl',
                    size: 'md',
                    resolve: { item: () => $scope.passengerOrder }
                });

                modalInstance.result.then(function (updatedOrder) {
                    if (updatedOrder && updatedOrder.Photos) {
                        $scope.passengerOrder.Photos = updatedOrder.Photos;
                    }
                });
            };

            // Delete a Photo
            $scope.deletePhoto = function (index) {
                $scope.passengerOrder.Photos.splice(index, 1);
            };

            // Save Order
            $scope.saveOrder = function () {

                if (
                    $scope.passengerOrder.OrderStatus === 'Not Delivered' &&
                    !$scope.passengerOrder.Reason
                ) {
                    $scope.passengerOrder.ReasonError = true;
                    return;
                }

                const updatedOrder = {
                    OrderNumber: $scope.passengerOrder.OrderNumber,
                    Status: $scope.passengerOrder.OrderStatus,
                    Feedback: $scope.passengerOrder.Feedback,
                    Reason: $scope.passengerOrder.Reason,
                    Photos: $scope.passengerOrder.Photos
                };

                const flattenedOrders = FlightOrdersFactory.getFlightOrdersFlattenedByFlightId($scope.flight.FlightId);
                const existingOrder = flattenedOrders.Orders.find(
                    o => o.OrderNumber === updatedOrder.OrderNumber
                );
                if (existingOrder) {
                    Object.assign(existingOrder, updatedOrder);
                } else {
                    flattenedOrders.Orders.push(updatedOrder);
                }

                FlightOrdersFactory.saveOrUpdateCabinReport($scope.flight.FlightId, flattenedOrders);

                const report = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight($scope.flight.FlightId);
                if (report) {
                    const reportOrder = report.FlightOrders.Orders.find(
                        o => o.OrderNumber === updatedOrder.OrderNumber
                    );
                    if (reportOrder) {
                        Object.assign(reportOrder, updatedOrder);
                    } else {
                        report.FlightOrders.Orders.push(updatedOrder);
                    }
                    report.updateTotals();
                    report.saveReport();
                }
        
                 // Close the modal
                 if ($scope.modalInstance) {
                    $scope.modalInstance.close($scope.passengerOrder);
                }
            };

            $scope.cancelOrder = function () {
                if ($scope.modalInstance) {
                    $scope.modalInstance.dismiss('cancel');
                }
            };
        }

        return {
            restrict: 'E',
            templateUrl: 'views/ShopInTheCloud/passengerShopOrders.tpl.html',
            scope: { flight: '=', passenger: '=',  modalInstance: '=', orderAvailability: '&onOrderAvailability'},
            link: link
        };
    }
})();
